import StepWrapper from "./StepWrapper";
import { Form } from "react-bootstrap";

const CodAmountStep = ({ data, onSubmit, totalSteps }) => (
  <StepWrapper
    step={data.step}
    total={totalSteps}
    onPrev={() => onSubmit({ step: data.step - 1 })}
    onNext={() => onSubmit({ step: data.step + 1 })}
  >
    <Form.Group>
      <Form.Label>COD Total Amount</Form.Label>
      <Form.Control
        type="number"
        placeholder="COD Amount"
        value={data?.cod?.totalCOD}
        onChange={(e) =>
          onSubmit({
            cod: {
              ...(data?.cod || {}),
              totalCOD: e.target.value,
            },
          })
        }
        required
        min={0}
        step="0.01"
        autoFocus
      />
    </Form.Group>
  </StepWrapper>
);

export default CodAmountStep;
